import React from 'react';
import './SharedComponents.css';

export const HorizontalSeparator = ({ color }) => (
    <hr className="separator-horizontal" style={{ color : color}}/>
    );


// WEBPACK FOOTER //
// ./src/components/Shared/SharedComponents.jsx